import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';

const QR = ({documento, size = 170}) => {
    const [codigoQr, setCodigoQr] = useState(false);

    useEffect(() => {
      if (documento?.documentStampUrl) {
          QRCode.toDataURL(documento.documentStampUrl).then(url => {
              setCodigoQr(url);
          });
      }
    }, [documento]);

    return (
        <>
            {codigoQr && (
                <img src={codigoQr} style={{width: `${size}px`, height: `${size}px`}}/>
            )}
            {documento?.securityCode && <div style={{fontSize: '12px', lineHeight: 1.2}}>
                Código de seguridad: {documento.securityCode}
            </div>}
            {documento?.signatureDate && (
                <div style={{fontSize: '12px', lineHeight: 1.2}}>
                    Fecha de firma digital: {documento.signatureDate}
                </div>
            )}
        </>
    )
}

export default QR;
